const isPermissionError = (error: any) => error.toString().includes('Permission denied');

export default isPermissionError;
